import VueRouter, { RouteConfig } from 'vue-router'

const HomeworkAiStepUpload = () => import('../views/homework-ai-plan/step-upload/index.vue')
const HomeworkAiStepResult = () => import('../views/homework-ai-plan/step-result/index.vue')

export const homeworkAiStepUploadRoute: RouteConfig = {
  path: '/homework-ai-plan/step-upload',
  name: 'homework_ai_step_upload',
  component: HomeworkAiStepUpload,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '上传/拍摄图片',
  },
}

export const homeworkAiStepResultRoute: RouteConfig = {
  path: '/homework-ai-plan/step-result',
  name: 'homework_ai_step_result',
  component: HomeworkAiStepResult,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '识别结果',
  },
}

export default [homeworkAiStepUploadRoute, homeworkAiStepResultRoute]
